import { isEqual } from 'lodash';
import { combineLatest } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import { activeScenarioOperations } from '@ardoq/core';
import { activeScenario$ } from 'streams/activeScenario/activeScenario$';
import { selectedSlide$ } from 'streams/selectedSlide/selectedSlide$';
import { slides$ } from 'streams/slides/slides$';
import { toSlideOnScreen } from './toSlideOnScreen';
import { featureContext$ } from 'streams/featureContext$';
import { isViewpointMode$ } from 'traversals/loadedGraph$';
import { focusedChromeOperations } from './focusedChromeOperations';
import { selectedModule$ } from 'appContainer/selectedModule$';

export const focusedChrome$ = combineLatest([
  activeScenario$,
  featureContext$,
  isViewpointMode$,
  selectedSlide$,
  slides$,
  selectedModule$,
]).pipe(
  map(
    ([
      activeScenario,
      featureContext,
      { isViewpointMode },
      selectedSlide,
      slides,
      { selectedModule },
    ]) =>
      focusedChromeOperations.toFocusedChrome({
        isInScenarioMode:
          activeScenarioOperations.isInScenarioMode(activeScenario),
        featureContext,
        isViewpointMode,
        slideOnScreen: toSlideOnScreen(selectedSlide, slides, selectedModule),
      })
  ),
  distinctUntilChanged(isEqual),
  shareReplay({ bufferSize: 1, refCount: true })
);

export const isFocusedChrome$ = focusedChrome$.pipe(
  map(focusedChromeOperations.isFocusedChrome),
  distinctUntilChanged()
);
